import { render, staticRenderFns } from "./CommissionReportDetail.vue?vue&type=template&id=3c07b956"
import script from "./CommissionReportDetail.vue?vue&type=script&lang=js"
export * from "./CommissionReportDetail.vue?vue&type=script&lang=js"
import style0 from "./CommissionReportDetail.vue?vue&type=style&index=0&id=3c07b956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports